module.exports = __webpack_public_path__ + "img/2110f87.jpg";